import { render } from "./Serp.vue?vue&type=template&id=70a1a5b7"
import script from "./Serp.vue?vue&type=script&lang=js"
export * from "./Serp.vue?vue&type=script&lang=js"

import "./serp.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__